import { Grid } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns';
import React, { useState } from 'react';

interface WeekSelectorProps {
  weekEnding: string;
  setWeekEnding: (date: string) => void;
  endOfWeekDay: number;
}
const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/**
 * Parse a date string (YYYY-MM-DD) as a local date at noon to avoid timezone shifts
 */
function parseLocalDate(dateStr: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day, 12, 0, 0);
}

/**
 * Format a date as YYYY-MM-DD in local time
 */
function formatLocalDate(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export default function WeekSelector({
  weekEnding,
  setWeekEnding,
  endOfWeekDay,
}: WeekSelectorProps) {
  const [error, setError] = useState<string>('');

  const handleChange = (date: Date | null) => {
    if (date) {
      if (date.getDay() !== endOfWeekDay) {
        setError(`Only ${daysOfWeek[endOfWeekDay]}s are allowed.`);
        setWeekEnding(formatLocalDate(date));
      } else {
        setError('');
        setWeekEnding(formatLocalDate(date));
      }
    } else {
      setError('');
      setWeekEnding('');
    }
  };

  return (
    <Grid item xs={12} sm={6}>
      <DatePicker
        label="Week Ending"
        value={weekEnding ? parseLocalDate(weekEnding) : null}
        onChange={handleChange}
        shouldDisableDate={(date) => date.getDay() !== endOfWeekDay}
        slotProps={{
          textField: {
            fullWidth: true,
            size: 'small',
            error: !!error,
            helperText: error,
          },
        }}
      />
    </Grid>
  );
}
